import { Injectable } from '@angular/core';
import { FoyerModel } from '../models/calcul/foyer.model';
import { RattachementLogementModel } from '../models/calcul/rattachement-logement.model';
import { CompoFoyerModel } from '../models/calcul/compofoyer.model';
import { PersonneModel } from '../models/calcul/personne.model';
import { SituationProfessionnelleModel } from '../models/calcul/situation-professionnelle.model';
import { RessourceModel } from '../models/calcul/ressource.model';
import { LogementModel } from '../models/calcul/logement.model';
import { AdresseModel } from '../models/calcul/adresse.model';
import { LoyerModel } from '../models/calcul/loyer.model';
import { SituationFamilialeModel } from '../models/calcul/situation-familiale.model';
import { EnfantService } from '../../02-declaration-enfant/components/enfant/services/enfant.service';
import { DeclarationModel } from '../../01-declaration/models/declaration.model';
import { CcdRubriqueMontantModel } from '@cnaf.usagers.appli/cnaf-commons-dral'
import { RessourcesEnfantModelAdapter } from '../../02-declaration-enfant/components/ressources-enfant/models/ressources-enfant.model';

@Injectable({ providedIn: 'root' })
export class MappingFluxService {

    /***
     * Flux IHM
     */
    declarationModel: DeclarationModel;

    /**
     * structure du body à mettre dans le body de la request pour l'appel au service de caclul
     */
    foyer: FoyerModel;

    rattachementLogementList: RattachementLogementModel[];
    compoFoyerList: CompoFoyerModel[];

    constructor(private readonly enfantService: EnfantService) { }

    /**
     * Permet de construire le flux json de type FoyerModel à mettre dans le body de la request pour l'appel au service de caclul
     * prestationalmiddle
     * @param declarationModel 
     */
    construireFlux(declarationModel: DeclarationModel): FoyerModel {

        this.foyer = new FoyerModel();
        // **************************************************************
        // Remplisage bloc logement :
        // **************************************************************
        this.foyer.rattachementLogementList = this.remplissageBlocRattachementLogement(declarationModel);

        // **************************************************************
        // Remplissage bloc compoFoyer :
        // **************************************************************
        this.compoFoyerList = new Array<CompoFoyerModel>();
        // Ajouter la liste des personnes
        this.compoFoyerList = this.remplissageBlocListePersonnes(declarationModel);

        // Completer la liste des personnes avec les enfants
        this.compoFoyerList = this.remplissageBlocListeEnfants(declarationModel, this.compoFoyerList);      

        // Liste des personnes adultes et enfants combinées
        this.foyer.compoFoyerList = this.compoFoyerList;

        // Remplissage bloc situation familiale
        this.foyer.situationFamilialeList = new Array<SituationFamilialeModel>();
        const situationFamilialeModelCalcul = new SituationFamilialeModel();

        this.foyer.situationFamilialeList.push(situationFamilialeModelCalcul);
        situationFamilialeModelCalcul.estEnCouple = declarationModel.sitFam.enCouple;
        situationFamilialeModelCalcul.situationFamille = declarationModel.sitFam.enCouple ? 'VIM' : 'CEL';

        return this.foyer;
    }


    /**
     * Construction bloc RattachementLogement
     * @param declarationModel
     * @returns Array<RattachementLogementModel>
     */
    remplissageBlocRattachementLogement(declarationModel: DeclarationModel): Array<RattachementLogementModel> {

        this.rattachementLogementList = new Array<RattachementLogementModel>();
        const rattachementLogementModelCalcul = new RattachementLogementModel();
        const logementCalcul = new LogementModel();
        const adresseCalcul = new AdresseModel();
        const loyerModelCalcul = new LoyerModel();

        rattachementLogementModelCalcul.flgColocation = ('COLOCATION' === declarationModel.logement.typeOccupation);
        
        logementCalcul.adresse = adresseCalcul;
        logementCalcul.loyer = loyerModelCalcul;
        adresseCalcul.codeInsee = declarationModel.logement.localite.codeInsee;

        logementCalcul.cdTypeLogement = declarationModel.logement.lieuResidence;
        logementCalcul.flgLogementConventionne = null;
        const isMetropole = this.enfantService.estMetropole( Number(declarationModel.logement.localite.codePostal) );
        if(declarationModel.logement.lieuResidence === 'MAISON_RETRAITE_EHPAD' && isMetropole
         && declarationModel.logement.estConventionne!=='SAIS_PAS') {
            logementCalcul.flgLogementConventionne = ('true' === declarationModel.logement.estConventionne);            
        }
            
        logementCalcul.flgMeubleLogement = ('true' === declarationModel.logement.estMeuble);
        logementCalcul.loyer.mtLoyerFoyer = declarationModel.logement.mttDeclare;
        
        if(declarationModel.logement.typeCrous !== undefined && declarationModel.logement.typeCrous !== "") {
            logementCalcul.typeLocal = declarationModel.logement.typeCrous;
        }
        rattachementLogementModelCalcul.logement = logementCalcul;

        this.rattachementLogementList.push(rattachementLogementModelCalcul);
        return this.rattachementLogementList;
    }

     /**
     * Construction bloc remplissageBlocListePersonnes
     * @param declarationModel
     * @returns Array<CompoFoyerModel> 
     */
    remplissageBlocListePersonnes(declarationModel: DeclarationModel): Array<CompoFoyerModel> {
        this.compoFoyerList = new Array<CompoFoyerModel>();

        let compoFoyerCalcul = new CompoFoyerModel();
        let personneCalcul = new PersonneModel();

        // Liste des personnes adultes
        declarationModel.listePersonnes.forEach(unePers => {

            compoFoyerCalcul = new CompoFoyerModel();
            personneCalcul = new PersonneModel();
            
            // DEM
            personneCalcul.enActivite = unePers.sitPro.enActivite;
            personneCalcul.estAuChomage = unePers.sitPro.auChomage;
            personneCalcul.flgDemandeur = ("DEMANDEUR" === unePers.typePersonne);
            personneCalcul.indemniseChomageMoisPrecedent = unePers.sitPro.indemnite;

            //regarde s'il y a une sitePro pour la personne
            if (unePers.sitPro != null) {
                personneCalcul.situationProfessionnelleList = new Array<SituationProfessionnelleModel>();
                const situationProfessionnelle = new SituationProfessionnelleModel();
                situationProfessionnelle.situationProfessionnelle = unePers.sitPro.codeSituation;
                personneCalcul.situationProfessionnelleList.push(situationProfessionnelle);
            }
            // regarde s'il y a des ressources pour la personne
            const ressourceListCalcul = new Array<RessourceModel>();
            if (unePers.ressources != null) {

                // Mettre des constantes
                this.ajouterUneRessourceAdulte(unePers.ressources.salaireDefini, "salaire", ressourceListCalcul, unePers.ressources.montantSalaire);
                this.ajouterUneRessourceAdulte( unePers.ressources.chomagePreretraitreDefini, "allocation_chomage", 
                                                ressourceListCalcul, unePers.ressources.montantChomagePreretraitre);
                this.ajouterUneRessourceAdulte( unePers.ressources.retraitrePensionDefini, "retraite_pension_imposable",
                                                ressourceListCalcul, unePers.ressources.montantRetraitrePension);
                this.ajouterUneRessourceAdulte( unePers.ressources.pensionAlimentaireDefini, "pension_alimentaire_recue",
                                                ressourceListCalcul, unePers.ressources.montantPensionAlimentaire);
                this.ajouterUneRessourceAdulte( unePers.ressources.revenuIndependentAnneeMoins2Defini, "revenu_travailleur_independant",
                                                ressourceListCalcul, unePers.ressources.montantRevenuIndependentAnneeMoins2);

            }
            personneCalcul.ressourceList = ressourceListCalcul;
            compoFoyerCalcul.personne = personneCalcul;
            this.compoFoyerList.push(compoFoyerCalcul);

        });

        return this.compoFoyerList;
    }

    /**
     * Construction bloc remplissageBlocListeEnfants
     * @param declarationModel
     * @returns Array<CompoFoyerModel> 
     */
    remplissageBlocListeEnfants(declarationModel: DeclarationModel, compoFoyerList: Array<CompoFoyerModel>): Array<CompoFoyerModel> { 
        
        let compoFoyerCalcul = new CompoFoyerModel();
        let personneCalcul = new PersonneModel();

        if (declarationModel.listeEnfants) {
            // Liste des enfants
            declarationModel.listeEnfants.forEach(unEnfant => {

                compoFoyerCalcul = new CompoFoyerModel();
                personneCalcul = new PersonneModel();

                
                // DEM
                compoFoyerCalcul.role = "ENF";
                personneCalcul.role = "ENF";
                personneCalcul.enfantACharge = unEnfant.moins21ans;
                personneCalcul.flgDemandeur = false;

                // sitpro
                if (unEnfant.codeSituationPro != null) {
                    const situationProfessionnelleModel = new SituationProfessionnelleModel();
                    const situationProfessionnelleList = new Array();
                    situationProfessionnelleModel.situationProfessionnelle = unEnfant.codeSituationPro;
                    situationProfessionnelleList.push(situationProfessionnelleModel);
                    personneCalcul.situationProfessionnelleList = situationProfessionnelleList;
                }

                const ressourceList = new Array<RessourceModel>();
                if (unEnfant.ressources != null) {
                    const ressourceAdapter = new RessourcesEnfantModelAdapter(unEnfant.ressources);
                    ressourceAdapter.mapRessources.forEach((rubrique : CcdRubriqueMontantModel, key : string) => {
                        if (rubrique.isActive) {
                            const ressourceCalcul = new RessourceModel();
                            ressourceCalcul.groupeOrigine = key;
                            ressourceCalcul.mtRessource = Number(rubrique.montant);
                            ressourceList.push(ressourceCalcul);
                        }
                    });
                }

                // calcul
                personneCalcul.ressourceList = ressourceList;

                compoFoyerCalcul.personne = personneCalcul;

                // Rempli le foyerCalcul dans la liste
                compoFoyerList.push(compoFoyerCalcul);
            });
        }

        return compoFoyerList;
    }

    /**
     * Ajoute une ressource d'une personne adulte
     * @param isRessourceDefini 
     * @param groupeOrigine 
     * @param ressourceListCalcul
     * @param montant 
     */
    public ajouterUneRessourceAdulte(isRessourceDefini: boolean, groupeOrigine: string, ressourceListCalcul: Array<RessourceModel>, montant: number) {

        if (isRessourceDefini) {
            const ressourceModelCalcul = new RessourceModel();
            ressourceModelCalcul.groupeOrigine = groupeOrigine;
            ressourceModelCalcul.mtRessource = montant;
            ressourceListCalcul.push(ressourceModelCalcul);
        }
    }

}
